<div
  #cardPromo
  class="card dg-card-promo {{classes}}"
  style="width: 100%;"
>
  <ng-content></ng-content>
</div>
